"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualizedMenuList = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = _interopRequireWildcard(require("react"));
var _reactWindow = require("react-window");
// Deactivating this for now - removing it is a breaking change.
// See https://git.lab.smartsheet.com/design-systems-team/lodestar-core/-/issues/493
// eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
const VirtualizedMenuListContainer = (0, _styled.default)("div")`
    // Can't just use padding OR margin because of the way react-window needs
    // to calc heights :)
    padding-bottom: 4px;
    margin-top: 4px;
`;
// See https://react-window.now.sh/#/examples/list/memoized-list-items
// This helps a LOT because for the most part the object is the same
// just isFocused is changed on items the user is interacting with.
const VirtualItem = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    data,
    index,
    style
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: style
  }, data[index]);
}, _reactWindow.areEqual);
VirtualItem.displayName = "VirtualItem";

/**
 * Leverages react-window's FixedSizeList to virtualize the menu list. This implementation works
 * best if the menu options have a fixed size.
 *
 * If the menu options don't have a fixed size, adjusting the itemHeight to fit the maximum-height
 * option will produce the best results, but ultimately you might want to provide a different
 * virtualization via the components overrides (perhaps using react-window's VariableSizeList).
 */
const VirtualizedMenuList = props => {
  const {
    className,
    children,
    innerRef,
    maxHeight,
    getOptionHeight
  } = props;
  const childrenArray = _react.default.Children.toArray(children);
  return /*#__PURE__*/_react.default.createElement(_reactWindow.VariableSizeList, {
    className: className,
    width: "100%",
    height: maxHeight,
    itemData: childrenArray,
    itemCount: childrenArray.length,
    itemSize: getOptionHeight,
    outerElementType: VirtualizedMenuListContainer,
    innerRef: innerRef
  }, VirtualItem);
};
exports.VirtualizedMenuList = VirtualizedMenuList;
//# sourceMappingURL=VirtualizedMenuList.js.map